<template>
	<div>
		<div class="tp-community-jxuh2"></div>
		<div class="tp-community-wrap">
			<div class="tp-community-l">
				<div class="tp-community-box">
					<div class="commun-tab-warp">
						<div class="commun-tab-l">
							<div @click="filterData.switchTabBtn(1)" class="commun-tab-l-item" :class="filterData.sort==1?'on':''">推荐</div>
							<div @click="filterData.switchTabBtn(2)" class="commun-tab-l-item" :class="filterData.sort==2?'on':''">最新</div>
						</div>
						<div class="commun-tab-r">
							<div class="commun-tab-search">
								<a-input allowClear
									v-model:value="filterData.keyword"
								    placeholder="请输入搜索内容"
								    style="width: 280px"
									class="default-search-icon-j187"
									@pressEnter="filterData.onSearch"
								    />
								<div class="commun-tab-search-imgs2" @click="filterData.onSearch"><img src="/img/community/search.png"/></div>
								
							</div>
						</div>
					</div>
					<div class="commun-list-box">
						<div v-if="listData.load" class="commun-list-loading"><a-spin /></div>
						<div v-for="(item,index) in listData.lists" :key="item.id" class="commun-list-item" @click="skipDetail(item.id)">
							<div class="commun-list-title text-warp-xhush">{{item.title}}</div>
							<div class="commun-list-desc text-warp-xhush" v-if="item.describe">{{item.describe}}</div>
							<div class="commun-list-img" v-if="item.enclosure_img">
								<div v-for="imgItem in item.enclosure_img" :key="item" class="commun-list-img-i">
									<img style="object-fit: cover;width:100%;height:100%;" :src="imgItem"/>
								</div>
							</div>
							<div class="commun-list-tags">
								<div class="commun-list-tags-l">
									<span class="commun-nickname">{{item.nickname}}</span>
									<span class="commun-numb-jsu1x"><img src="/img/community/views.png"/><text>{{item.click_num}}</text></span>
									<span>{{item.created_time?item.created_time:item.created_at}}</span>
								</div>
								<div class="commun-list-tags-r"><span>回复({{item.comment_num}})</span></div>
							</div>
						</div>
						<div v-if="!listData.load&&listData.lists.length<1" class="commun-list-empty">
							<a-empty image="/img/community/icon-tu.png">
								<template #description>
								    <span v-if="filterData.keyword">搜索结果不存在，请换个关键词重新搜索</span>
								    <span v-else>暂无提问</span>
								</template>
								<!-- <a-button v-if="!filterData.keyword" size="large" type="primary" @click.stop="addCommunityQuiz">去提问</a-button> -->
							</a-empty>
						</div>
					</div>
				</div>
				<div class="tp-community-pagination"><a-pagination @change="filterData.paginationChange" v-model:current="filterData.page" v-model:pageSize="filterData.size" :total="filterData.total" show-less-items hideOnSinglePage /></div>
			</div>
			<div class="tp-community-r">
				<div class="tp-community-quiz-box">
					<div class="community-quiz-header">
						<div class="community-quiz-item" @click="mineSkipBtn(2)">
							<div class="community-quiz-number">{{numberData.answerNum}}</div>
							<div>回答</div>
						</div>
						<a-divider type="vertical" style="top: 3px;height: 48px; background-color: #F1F1F2" />
						<div class="community-quiz-item" @click="mineSkipBtn(1)">
							<div class="community-quiz-number">{{numberData.questionNum}}</div>
							<div>提问</div>
						</div>
					</div>
					<div class="community-quiz-btn"><a-button @click.stop="addCommunityQuiz" size="large" type="primary" block style="line-height: 1;">去提问</a-button></div>
				</div>
			</div>
		</div>
		<communityQuiz ref="communityQuizRef" @communityQuizCallback="communityQuizCallback"></communityQuiz>
	</div>
</template>

<script>
	import {Empty,Modal,message,Form} from 'ant-design-vue';
	import communityQuiz from "/src/components/communityQuiz.vue";
	import config from "/src/config/config.js";
	import baseFunc from '/src/config/base_func.js';
	import { createVNode } from 'vue';
	export default {
		name: 'CommunityList',
		components: {
			communityQuiz
		},
		data() {
			return {
				userinfo:null,/*用户登录情况*/
				simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
				numberData:{
					questionNum:0,//提问数
					answerNum:0,//回答数量
				},
				filterData:{
					page:1,//当前页
					size:20,//每页数量
					total:0,//总条数
					keyword:"",
					input_keyword:"",
					sort:1,//1=推荐 2= 最新
					switchTabBtn:(val)=>{
						this.filterData.page = 1;
						this.filterData.sort = val;
						this.questionsList();
					},
					onSearch:(e)=>{
						this.filterData.page = 1;
						// this.filterData.keyword=this.filterData.input_keyword
						this.questionsList();
					},
					paginationChange:(page, pageSize)=>{
						this.questionsList();
					}
				},
				listData:{
					load:false,
					lists:[]
				},
			}
		},
		created: function() {
			this.statisticalQuantity();
			this.questionsList();
		},
		methods: {
			/* 获取数量*/
			statisticalQuantity(){
				this.$apiRequest.post("/user/statisticalQuantity", {}).then(res => {
					this.numberData = res.data.data
				}).catch(err => {
				});
			},
			/*获取问题列表*/
			questionsList(){
				if(this.listData.load)return false;
				this.listData.load=true;
				this.$apiRequest.post("/user/questionsList", {
					page:this.filterData.page,
					size:this.filterData.size,
					keyword:this.filterData.keyword,
					sort:this.filterData.sort,
				}).then(res => {
					this.listData.lists=res.data.data.data;
					this.filterData.total = res.data.data.total;
					this.listData.load=false;
				}).catch(err => {
					this.listData.load=false;
				    if(err.data)this.$baseFunc.checkState(err.data)
				});
			},
			
			/*提问*/
			addCommunityQuiz(){
				this.$refs.communityQuizRef.openCommunityQuiz();
			},
			communityQuizCallback(data){
				this.questionsList()
			},
			/*跳转详情*/
			skipDetail(id){
				if(config.devEnv=='dev'){
					window.open('/community/detail.html?id='+id);
				}else{
					window.open('/question/'+id);
				}
			},
			mineSkipBtn(way){
				baseFunc.checkUserLogin(this,true,true).then(()=>{
					if(config.devEnv=='dev'){
						window.open('/community/mine.html?way='+way);
					}else{
						if(way==1){
							/*提问*/
							document.location.href='/mine/answer';
						}else if(way==2){
							/*回答*/
							document.location.href='/mine/ask';
						}
					}
				}).catch((err)=>{
				})
			},
		}
	}
</script>
<style>
	
	.default-search-icon-j187 .ant-input-search-button{
		border-left: 0;
		line-height: 1;
		border-color: #d9d9d9 !important;
		padding: 4px 12px;
	}
	.default-search-icon-j187 .ant-input,.default-search-icon-j187 .ant-input-affix-wrapper{
		box-shadow:unset !important;
		border-color: #d9d9d9 !important;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		border-right:0;
	}
	.default-search-icon-j187 .ant-input-search-button::after{display: none;}
</style>
<style scoped>
	.text-warp-xhush{
		word-wrap: break-word;
		word-break: break-all;
	}
	.tp-community-jxuh2{
		width: 100%;
		height: 60%;
		background-image: linear-gradient(#ecf3fc,#fff);
		position: absolute;
		top: 0;
		left: 0;
	}
	.tp-community-wrap{
		width: 1200px;
		margin: 24px auto 0;
		padding: 0;
		position: relative;
		display: flex;
		justify-content: space-between;
	}
	.tp-community-wrap .tp-community-l{
		max-width: 840px;
		flex: 1;
	}
	.tp-community-box{
		width: 100%;
		border: 1px solid #EFF2F6;
		background-color: #ffffff;
	}
	.commun-tab-warp{
		width: 100%;
		padding: 0 30px;
		display: flex;
		align-items: center;
		height: 59px;
		justify-content: space-between;
		box-sizing: border-box;
		border-bottom: 1px solid #EFF2F6;
	}
	.commun-tab-l{
		display: flex;
		height: 100%;
	}
	.commun-tab-l .commun-tab-l-item{
		height: 100%;
		padding: 0 20px;
		display: flex;
		align-items: center;
		font-size: 16px;
		color: #010101;
		transition: color 0.2s;
		cursor: pointer;
	}
	.commun-tab-l .commun-tab-l-item:first-child{padding-left: 0;}
	.commun-tab-l .commun-tab-l-item:hover{color: #2552F4;}
	.commun-tab-l .commun-tab-l-item.on{color: #2552F4;-webkit-text-stroke: 0.2px #2552F4;}
	
	.commun-tab-search{
		position: relative;
	}
	.commun-tab-search .commun-tab-search-imgs2{
		position: absolute;
		width: 32px;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		left: 5px;
		top:0;
		cursor: pointer;
	}
	.commun-tab-search-imgs2 img{width: 16px;height: 16px;}
	.commun-tab-search .default-search-icon-j187{
		padding-left: 39px;
	}
	
	.commun-list-box{
		padding: 0 30px;
		margin: 0;
		box-sizing: border-box;
		position: relative;
	}
	.commun-list-loading{
		position: absolute;
		z-index: 2;
		left: 0;
		top: 0;
		margin: auto;
		background-color: rgba(255,255,255,.3);
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 300px;
	}
	.commun-list-empty{
		position: absolute;
		z-index: 1;
		left: 0;
		top: 0;
		margin: auto;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 300px;
		background-color: #ffffff;
	}
	.commun-list-box .commun-list-item{
		padding: 23px 0 26px;
		position: relative;
		box-sizing: border-box;
		cursor: pointer;
	}
	.commun-list-box .commun-list-item::after{
		content: " ";
		position: absolute;
		width: calc(100% + 60px);
		left: -30px;
		height: 1px;
		background-color: #F0F2F7;
		bottom: 0;
	}
	.commun-list-box .commun-list-item:last-child::after{
		height: 0;
		background-color: rgba(0,0,0,0);
	}
	
	.commun-list-item .commun-list-title{
		width: 100%;
		font-size: 18px;
		font-weight: 600;
		color: #010101;
		margin-bottom: 10px;
	}
	.commun-list-item .commun-list-desc{
		font-size: 15px;
		color: #636363;
		width: 100%;
		text-overflow: ellipsis;
		overflow: hidden;
		display: -webkit-box !important;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		white-space: normal;
	}
	.commun-list-item .commun-list-img{
		margin-top: 12px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	.commun-list-img .commun-list-img-i{
		width: 80px;
		height: 80px;
		border: 1px solid #E9EBEC;
		cursor: pointer;
		border-radius: 4px;
		overflow: hidden;
	}
	.commun-list-img .commun-list-img-i + .commun-list-img-i{
		margin-left: 10px;
	}
	.commun-list-item .commun-list-tags{
		margin-top: 16px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 22px;
		color: #959595;
		font-size: 14px;
	}
	.commun-list-tags .commun-list-tags-l{
		display: flex;
	}
	.commun-list-tags-l .commun-nickname{
		margin-right: 24px;
	}
	.commun-list-tags .commun-list-tags-r{
		display: flex;
		align-items: center;
		height: 100%;
	}
	.commun-list-tags-r>span{
		margin-left: 25px;
		display: flex;
		align-items: center;
		color: #5A6D96;
		font-size: 15px;
		transition: color 0.2s;
	}
	.commun-list-tags-r>span:hover{
		color:#2552F4;
	}
	.commun-numb-jsu1x{
		margin-right: 24px;
		color: #959595;
		display: flex;
		align-items: center;
	}
	.commun-numb-jsu1x img{
		width: 18px;
		margin-right: 3px;
	}
	.commun-numb-jsu1x .commun-list-tags-r-comment-img{
		width: 16px;
		position: relative;
		top: 1px;
	}
	
	.tp-community-pagination{
		margin: 24px 0;
		width: 100%;
		text-align: center;
		transform: scale(0.78125);
	}
	.tp-community-wrap .tp-community-r{
		min-width: 340px;
		width: 340px;
	}
	.tp-community-quiz-box{
		width: 100%;
		background-color: #ffffff;
		border: 1px solid #EFF2F6;
	}
	.community-quiz-header{
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.community-quiz-item{
		text-align: center;
		color: #aaaaaa;
		flex: 1;
		padding: 28px 0 26px;
		cursor: pointer;
	}
	.community-quiz-item .community-quiz-number{
		font-size: 18px;
		font-weight: 400;
		color: #292929;
		font-weight: 600;
		margin-bottom: 10px;
	}
	.community-quiz-btn{
		padding: 0 38px 38px;
		box-sizing: border-box;
	}
	
	/*移动端*/
	@media screen and (max-device-width: 450px){
		.tp-community-wrap {width: 100%;}
		.commun-list-box,.commun-tab-warp{padding: 0 16px;}
		.commun-list-box .commun-list-item[data-v-4e7d3afa]::after{width: calc(100% + 32px);left: -16px;}
		.tp-community-wrap .tp-community-r,.commun-tab-warp .commun-tab-r{display: none;}
		.tp-community-wrap .tp-community-l{border: unset;}
	}
	
</style>
